import { api, unwrapResponse } from './api';

function viewerTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Asia/Kolkata';
  } catch {
    return 'Asia/Kolkata';
  }
}

export const dashboardService = {
  getSummary: () =>
    api
      .get(`/insights/summary?tz=${encodeURIComponent(viewerTimezone())}`)
      .then(unwrapResponse),
};
